var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.calendarInCart)?_c('div',{staticClass:"cz2__review-views__view-calendar"},[_c('button',{staticClass:"cz2__review-views__view cz2__review-views__view--active",attrs:{"type":"button","aria-label":"View holiday calendar info"},on:{"click":_vm.openCalendarModal}},[_c('span',{staticClass:"cz2__review-views__view-image",style:({
                backgroundImage: `url(${_vm.calendarPreviewImage})`,
            })})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }